<template lang="html">
  <div class="wrapper" v-show="pageReady">
    <ShareHeader :openTarget="'class/detail?id=' +  buyTogether.course_id" />
    <div class="topVideoWrapper" :style="{backgroundImage: 'url('+ videoPoster +')'}">
      <div class="playButton">
        <img src="@/assets/image/course/play.png" alt="">
      </div>
      <WxOpenTag :extinfo="'class/detail?id=' + buyTogether.course_id" />
    </div>

    <div class="topTitleSection">
      <div class="mainTitle">
        {{courseData.title}}
      </div>
      <div class="topEvaluate">
        <img src="../../assets/image/course/star.png" alt="" class="star">
        <div class="comment">
          <div class="comment_con">
            <img src="../../assets/image/course/favor.png" alt="" class="icon">
            <p>12</p>
          </div>
          <div class="comment_con">
            <img src="../../assets/image/course/comment.png" alt="" class="icon">
            <p>12</p>
          </div>
        </div>
      </div>
      <div class="topUser">
        <img :src="courseData.avatar" alt="">
        <div class="username">{{courseData.username}}</div>
      </div>
    </div>

    <div class="course_con">
      <ul class="tab_tilte">
        <li class="tab_mod" @click="cur = 0" :class="{active:cur == 0}">
          详情
        </li>
        <li class="tab_mod" @click="cur = 1" :class="{active:cur == 1}">
          目录
        </li>
      </ul>
      <div class="tab_content">
        <div v-show="cur == 0">
          <div class="describe" v-html="courseData.about"></div>
        </div>
        <div v-show="cur == 1">
          <Catalogue :catalogueList="catalogueList" ref="ynk" />
        </div>
      </div>
    </div>
    <div class="down_btn">
      <div class="download">
        <img src="@/assets/image/course/download.png" alt="">
        <WxOpenTag :extinfo="'class/detail?id=' + buyTogether.course_id" />
      </div>

      <div class="original_price" @click="purchase">
        <p>￥{{buyTogether.orign_price}}</p>
        <p>单独购买</p>
        <WxOpenTag ref="wxopentag" :extinfo="'class/detail?id=' + buyTogether.course_id" />
      </div>
      <div class="current_price" @click="invite">
        <p>￥{{buyTogether.price}}</p>
        <p>发起{{buyTogether.number}}人团</p>
      </div>
    </div>

    <Login ref="login" @login="loginCallback" />

    <div class="userInformation" v-show="userInformationShow">
      <div class="userForm">
        <p>信息提交</p>
        <input type="" placeholder="请输入你的姓名" class="studentName" name="studentName" maxlength="20" v-model="studentName">
        <input type="" placeholder="请输入你的学校" class="school" name="school" maxlength="20" v-model="school">
        <input type="" placeholder="你的学院" class="college" name="college" maxlength="20" v-model="college">
        <input type="" placeholder="指导老师" class="teacher" name="teacher" maxlength="20" v-model="teacher">
        <div class="submitBtn" :class="{cover: getUserFormData}" @click="getSubmitBtn"> 提交 </div>
      </div>
    </div>
  </div>
</template>

<script>
  import utils from '@/utils/utils'
  import WxShare from '@/utils/wxshare'
  import Storage from '@/utils/localStore'
  import ShareHeader from '@/components/HeadModule'
  import WxOpenTag from '@/components/WxOpenTag'
  import Login from '@/components/loginModule/Login'
  import Catalogue from './com/Catalogue'
  import {
    appId
  } from '@/utils/http'

  let userPro = {}

  export default {
    data() {
      return {
        pageReady: false,
        togetherId: this.$route.query.tid || '',
        buyTogether: {},
        courseData: {},
        catalogueList: [],
        videoPoster: '',
        cur: 0,
        
        userInformationShow: false,
        studentName: '',
        school: '',
        college: '',
        teacher: '',
        spellingData: {},
      }
    },
    computed: {
      getUserFormData() {
        return this.studentName && this.school && this.college && this.teacher
      }
    },

    created() {
      this.checkUserPro()
    },

    mounted() {
      if (utils.browserChecker.isWx()) {
        this.$refs.wxopentag.register()
      }
    },
    methods: {
      checkUserPro() {
        let user = Storage.getItem('pink_user_pro')
        if (user) {
          userPro = user
          this.init()
          this.pageReady = true
        } else {
          let code = utils.getQuery('code', location.href)
          if (!code) {
            let open = encodeURIComponent(location.href)
            /*是否是在微信中打开在跳这个页面的时候这里会判断*/
            let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${open}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
            window.location.href = url
          } else {
            this.$http.get('/user/wxUserInfo', {
              params: {
                code: code,
                appid: appId,
                scene: '3',
              }
            }).then(res => {
              if (res.code >= 0) {
                userPro = res.data
                this.storeUserPro()
                this.init()
                /*用户授权之后 -> 拿到用户信息 才显示页面*/
                this.pageReady = true
              } else if (res.code == -888) {
                /*当code已经被使用过时，重新获取当前页面的code*/
                let curl = location.origin + location.pathname + location.hash
                let open = encodeURIComponent(curl)
                let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${open}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
                location.replace(url)
              } else {
                utils.showMessage('用户授权失败')
              }
            })
          }
        }
      },

      init() {
        this.wxshare = new WxShare()
        this.getTogetherInfo()
      },

      getTogetherInfo() {
        this.$http.get('/course/buyTogetherDetail', {
          params: {
            id: this.togetherId,
            uid: userPro.uid,
            token: userPro.token
          }
        }).then(res => {
          if (res.code >= 0) {
            let data = res.data
            this.buyTogether = data.buy_together_info
            
            if(userPro.uid && userPro.token){
              if (this.buyTogether.is_additional_information == 1){
                this.$http.get('/course/getTogetherUserInfo', {
                  params: {
                    uid: userPro.uid || '',
                    token: userPro.token || '',
                    reg_channel: 'buy_together',
                  }
                }).then(res => {
                  if (res.code >= 0) {
                    this.school = res.data.school;
                    this.college = res.data.college;
                    this.studentName = res.data.student_name;
                    this.teacher = res.data.adviser;
                  }
                })
              }
            }          
            
            this.courseData = data.course_info
            document.title = this.courseData.title
            this.videoPoster = this.courseData.pic
            this.getCatalogueList()
            this.wxshare.share({
              title: this.courseData.title,
              desc: this.courseData.username,
              link: window.location.href,
              imgUrl: this.courseData.pic
            })
          }
        })
      },
      getCatalogueList() {
        this.$http.get('/edu/listChapter', {
          params: {
            course_id: this.courseData.courseid
          }
        }).then(res => {
          if (res.code >= 0) {
            this.catalogueList = res.data
          }
        })
      },
      purchase() {
        this.callApp()
      },
      invite() {
        if (userPro.uid && userPro.token) {
          this.$http.get('/course/startTogetherBuy', {
            params: {
              uid: userPro.uid,
              token: userPro.token,
              id: this.togetherId,
            }
          }).then(res => {
            if (res.code == 0) {
              this.spellingData = res.data
              this.userInformationShow = true;
            } else if (res.code == -888) {
              let data = res.data
              this.spellingData = res.data
              if (data.join_status == 1) {
                this.$router.push({
                  path: '/participant',
                  query: {
                    tid: this.spellingData.buy_together_id,
                    tcode: this.spellingData.together_code
                  }
                })
              } else if (data.join_status == 2) {
                this.userInformationShow = true;
              }
            } else if (res.code == -50) {
              utils.showMessage('登录已过期，请重新登录')
              this.login()
            } else {
              utils.showMessage(res.msg)
            }
          })
        } else {
          this.login()
        }
      },
      login() {
        this.$refs.login.show({
          openid: userPro.openid,
          togetherId: this.togetherId
        })
      },
      loginCallback(uinfo = {}) {
        Object.assign(userPro, uinfo)
        this.storeUserPro()
      },
      storeUserPro() {
        Storage.setItem('pink_user_pro', userPro)
        this.getTogetherInfo();
      },

      getSubmitBtn() {
        if (this.getSubmitBtn) {
          this.$http.get('/course/saveTogetherUserInfo', {
            params: {
              uid: userPro.uid,
              token: userPro.token,
              buy_together_id: this.togetherId,
              school: this.school,
              college: this.college,
              student_name: this.studentName,
              adviser: this.teacher,
              reg_channel: 'buy_together',
            }
          }).then(res => {
            if (res.code >= 0) {
              this.userInformationShow = false;
              this.$router.push({
                path: '/invite',
                query: {
                  tid: this.spellingData.buy_together_id,
                  tcode: this.spellingData.together_code,
                }
              })
            }
          })
        }
      },
    },
    components: {
      ShareHeader,
      Login,
      Catalogue,
      WxOpenTag,
    }
  }
</script>

<style lang="css" scoped>
  .wrapper {
    box-sizing: border-box;
    height: 100%;
    background-color: #F7F8F8;
    padding-bottom: 8rem;
  }

  .topVideoWrapper {
    position: relative;
    padding-top: 19rem;
    padding-top: calc(100% / 1.44 - 50);
    background: #d8d8d8 no-repeat;
    background-size: cover;
    background-position: center;
  }

  .playButton {
    position: absolute;
    width: 5.5rem;
    height: 5.5rem;
    top: 50%;
    left: 50%;
    margin-left: -2.75rem;
    margin-top: -2.75rem;
  }

  .playButton>img {
    width: 5.5rem;
    height: 5.5rem;
    object-fit: contain;
  }

  .topTitleSection {
    padding: 2rem 1.5rem 1.5rem 1.5rem;
    color: #1d2023;
    background-color: #FFFFFF;
  }

  .mainTitle {
    font-size: 1.6rem;
    font-weight: bolder;
    color: #1d2023;
    margin: 0;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  .topEvaluate {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1rem;
    margin-top: 1.5rem;
  }

  .star {
    height: 1.3rem;
  }

  .comment {
    display: flex;
  }

  .comment_con {
    display: flex;
    margin-left: 2rem;
  }

  .icon {
    height: 1.7rem;
  }

  .topUser {
    display: flex;
    align-items: center;
    margin-top: 1rem;
  }

  .topUser img {
    width: 3rem;
    height: 3rem;
    object-fit: cover;
    border-radius: 1.5rem;
  }

  .username {
    margin-left: .8rem;
    font-size: 1.4rem;
    color: #3F454B;
  }

  .course_con {
    margin-top: 1rem;
    background-color: #FFFFFF;
    box-sizing: border-box;
    padding: 0 1.5rem;
  }

  .tab_tilte {
    width: 100%;
    height: 4.4rem;
    display: flex;
    border-bottom: .1rem solid rgba(0, 0, 0, 0.07);
  }

  .tab_mod {
    position: relative;
    width: 50%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    font-size: 1.6rem;
    font-weight: bolder;
    color: #1D2023;
    z-index: 2;
  }

  .active {
    color: #FF0225;
  }

  .active:after {
    content: '';
    position: absolute;
    left: 50%;
    top: 0;
    text-align: center;
    border-radius: 1.5px;
    width: 3.3rem;
    height: .2rem;
    margin-top: 4.1rem;
    margin-left: -1.6rem;
    background-color: #FF0225;
    border-radius: .6rem;
    z-index: 1;
  }

  .describe {
    box-sizing: border-box;
    padding: 2rem 0;
  }

  .describe>>>img {
    max-width: 100%;
  }

  /* 按钮 */
  .down_btn {
    box-sizing: border-box;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.0);
    z-index: 3;
    position: fixed;
    align-items: center;
    left: 0;
    bottom: 0;
    justify-content: center;
    display: flex;
    justify-content: center;
    padding: 1.5rem 2.5rem;
  }

  @media (min-width: 751px) {
    .down_btn {
      width: 750px;
      left: 50%;
      margin-left: -375px;
    }
  }

  .download {
    width: 7.2rem;
    position: absolute;
    right: 0;
    margin-top: -15rem;
  }

  .download img {
    width: 100%;
  }

  .original_price {
    position: relative;
    width: 15rem;
    height: 5rem;
    color: #FFFFFF;
    background-color: #F3ABA7;
    border-radius: 2.5rem 0 0 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 1.5rem;
  }

  .current_price {
    width: 15rem;
    height: 5rem;
    color: #FFFFFF;
    background-color: #E6001F;
    border-radius: 0 2.5rem 2.5rem 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 1.5rem;
  }

  .userInformation {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.60);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .userForm {
    box-sizing: border-box;
    width: 30rem;
    height: 37.75rem;
    padding: 0 1.3rem;
    background-color: #FFFFFF;
    border-radius: 1rem;
  }

  .userForm p {
    text-align: center;
    margin-top: 2.45rem;
    margin-bottom: 1.05rem;
    font-size: 1.8rem;
    font-weight: 600;
  }

  input {
    box-sizing: border-box;
    padding: 1.5rem 0.5rem; 
    border: none;
    outline: none;
    background-color: #F5F5F7;
    margin-top: 1.5rem;
  }

  .studentName,
  .school,
  .college,
  .teacher {
    width: 100%;
    height: 4.4rem;
    font-size: 1.3rem;
    border-radius: .8rem;
  }

  .studentName[name="studentName"]::-webkit-input-placeholder {
    color: #BDBDBD;
  }

  .school[name="school"]::-webkit-input-placeholder {
    color: #BDBDBD;
  }

  .college[name="college"]::-webkit-input-placeholder {
    color: #BDBDBD;
  }

  .teacher[name="teacher"]::-webkit-input-placeholder {
    color: #BDBDBD;
  }

  .submitBtn {
    width: 100%;
    height: 4.55rem;
    background: #FCD0CB;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4.55rem;
    margin-top: 2rem;
    font-size: 1.8rem;
    color: #FFFFFF;
  }

  .cover {
    background: linear-gradient(#FE405A 0%, #E50101 100%);
  }
</style>